import React from "react";
import { Box, ToggleButton, ToggleButtonGroup } from "@mui/material";

const toggleButtonRootSx = {
    px: 1.5,
    minHeight: 44,
    textTransform: "none",
    "&.Mui-selected": {
        backgroundColor: "#3BA666",
        color: "white",
        "&:hover": { backgroundColor: "#2e7d32" },
    },
};

const toggleSx = {
    "& .MuiToggleButton-root": toggleButtonRootSx,
};

const compactToggleSx = {
    "& .MuiToggleButton-root": {
        ...toggleButtonRootSx,
        px: 1,
        py: 0,
        height: 26,
        minHeight: 26,
        fontSize: "0.75rem",
        lineHeight: 1,
    },
};

/** `true` / `false` for list APIs that accept `free`; `undefined` means no filter. */
export function accessFilterToFreeParam(accessFilter) {
    const af = String(accessFilter ?? "all").toLowerCase();
    if (af === "free") return true;
    if (af === "paid" || af === "premium") return false;
    return undefined;
}

/** Client filter when the list endpoint does not take `free` (featured shelves). */
export function matchesAccessFilter(isFree, accessFilter) {
    const af = String(accessFilter ?? "all").toLowerCase();
    if (af === "all") return true;
    if (af === "free") return isFree === true;
    if (af === "paid" || af === "premium") return isFree !== true;
    return true;
}

/**
 * All / Free / Premium toggle. Place above the tag chips, aligned to the right.
 */
export default function BrowseAccessFilter({ value, onChange, t, compact = false }) {
    return (
        <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 1.5 }}>
            <ToggleButtonGroup
                value={value}
                exclusive
                size="small"
                onChange={(_, next) => {
                    if (next != null) onChange(next);
                }}
                aria-label={t("puzzles-browse.filter-tier-label", "Show")}
                sx={compact ? compactToggleSx : toggleSx}
            >
                <ToggleButton value="all">
                    {t("puzzles-browse.filter-tier-all", "All")}
                </ToggleButton>
                <ToggleButton value="free">
                    {t("puzzles-browse.filter-tier-free", "Free")}
                </ToggleButton>
                <ToggleButton value="paid">
                    {t("puzzles-browse.filter-tier-premium", "Premium")}
                </ToggleButton>
            </ToggleButtonGroup>
        </Box>
    );
}
